import React from 'react';
import { CheckCircle2Icon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { BoxImage } from './BoxImage';
import { offerBullets } from '../data/content';
export function Offer() {
  return <section id="offer" className="scroll-mt-2 border-y-4 border-safety bg-graphite px-3 py-4 sm:px-6" data-id="element-118" data-mp="1mmh72e0sz8hy">
      <div className="mx-auto max-w-xl text-center" data-id="element-119" data-mp="1hph266fowbsf">
        <p className="inline-block rounded-full bg-warning px-3 py-0.5 text-[0.68rem] font-black uppercase tracking-[0.2em] text-carbon sm:text-xs" data-id="element-120" data-mp="tyv5tcf1sfy9">
          SPECIAL LAUNCH OFFER
        </p>
        <h2 className="mt-1.5 font-display text-[1.7rem] font-bold uppercase leading-none text-white sm:text-[2.4rem]" data-id="element-121" data-mp="p24ratiw5sey">
          🦺 SAFETY <span className="text-safety" data-id="element-122" data-mp="yxes5dxjztr5">INSPECTION PRO™</span>
        </h2>
        <p className="mt-1 text-[0.68rem] font-bold uppercase tracking-wide text-mist sm:text-[0.84rem]" data-id="element-123" data-mp="2fc6asz4wdmn9">
          THE COMPLETE WORKPLACE SAFETY INSPECTION SYSTEM
        </p>

        <BoxImage className="mx-auto mt-2 max-w-[260px] sm:max-w-[330px]" target="checkout" data-id="element-124" data-mp="2af7hgit25jq4" />

        <div className="mt-2 rounded-md border-2 border-safety bg-carbon px-3 py-2.5 text-left" data-id="element-125" data-mp="pjz4ly943o0d">
          <p className="text-center font-display text-[1.05rem] font-bold uppercase tracking-wide text-safety sm:text-[1.25rem]" data-id="element-126" data-mp="uhh3evtf0mun">
            Complete 6-in-1 System
          </p>
          <ul className="mt-1.5 grid gap-1 sm:grid-cols-2" data-id="element-127" data-mp="13ip1bcs0rlo7">
            {offerBullets.map(b => <li key={b} className="flex items-start gap-1.5" data-id="element-128" data-mp="6v0wfwgyxpml">
                <CheckCircle2Icon className="mt-[1px] h-3.5 w-3.5 shrink-0 text-safety" strokeWidth={2.5} aria-hidden="true" data-id="element-129" data-mp="bsasvw2rz1jx" />
                <span className="text-[0.76rem] leading-tight text-white sm:text-[0.86rem]" data-id="element-130" data-mp="ftm8r9vuk8ex">{b}</span>
              </li>)}
          </ul>
          <p className="mt-2.5 text-center text-[0.82rem] font-black uppercase leading-tight text-white sm:text-[1.02rem]" data-id="element-131" data-mp="3k8m1cvcqk533">
            🔥 GET SAFETY INSPECTION PRO™ TODAY —{' '}
            <span className="whitespace-nowrap rounded bg-safety px-1.5 text-carbon" data-id="element-132" data-mp="3o84m9r4k4g5x">$27 USD</span>
          </p>
          <div className="mt-2.5" data-id="element-133" data-mp="vde7b2r0ny4l">
            <CTAButton label="🦺 GET INSTANT ACCESS" sub="Immediate Digital Access" target="checkout" data-id="element-134" data-mp="qhfnztkjp6b1" />
          </div>
          <p className="mt-2 text-center text-[0.66rem] font-bold uppercase tracking-wide text-white/85 sm:text-xs" data-id="element-135" data-mp="1548t660covpi">
            🛡️ 7-Day Money-Back Guarantee
          </p>
        </div>
      </div>
    </section>;
}